import {addSuccessMessage} from "../core/errors/errorSlice";
import {store} from "../app/store";


export default (config: any) => {
    if(config && config.data && config.data.message){
        store.dispatch(addSuccessMessage({title: config.data.message}));
    }
    return config;
}
